import { api } from './auth/authService';

// Obtener todos los aircraft
export const getAircrafts = async () => {
  try {
    const response = await api.get('/api/v1/aircrafts/');
    return response.data;
  } catch (error) {
    console.error('Error fetching aircrafts:', error);
    return [];
  }
};

// Obtener aircraft asignados al piloto actual
export const getPilotAircrafts = async () => {
  try {
    // Primero obtener el ID del piloto
    const pilotResponse = await api.get('/api/v1/pilots/me/');
    if (pilotResponse.data && pilotResponse.data.id) {
      const pilotId = pilotResponse.data.id;
      console.log('ID del piloto:', pilotId);
      
      // Usar el endpoint existente en AircraftPilot
      const response = await api.get(`/api/v1/aircraft-pilots/by-pilot/${pilotId}/`);
      console.log('Respuesta completa:', response.data);
      
      // Extraer los detalles de los aircraft de las asignaciones
      const aircrafts = response.data.map(assignment => assignment.aircraft_details);
      console.log('Aircraft extraídos:', aircrafts);
      return aircrafts;
    } else {
      console.error('No se pudo obtener el ID del piloto');
      return [];
    }
  } catch (error) {
    console.error('Error fetching pilot aircrafts:', error);
    return [];
  }
};

// Obtener un aircraft por ID
export const getAircraftById = async (id) => {
  try {
    const response = await api.get(`/api/v1/aircrafts/${id}/`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching aircraft with id ${id}:`, error);
    throw error;
  }
};